import React, { createContext, useContext, useMemo } from 'react';
export var TabsRenderMode;
(function (TabsRenderMode) {
  TabsRenderMode["TAB"] = "tab";
  TabsRenderMode["CONTENT"] = "content";
})(TabsRenderMode || (TabsRenderMode = {}));
export var TabsContext = /*#__PURE__*/createContext(null);
export var TabTypes;
(function (TabTypes) {
  TabTypes["PLAIN"] = "plain";
  TabTypes["CHIPS"] = "chips";
  TabTypes["SEGMENTED"] = "segmented";
})(TabTypes || (TabTypes = {}));
export var useTabsContext = function useTabsContext() {
  var context = useContext(TabsContext);
  if (!context) throw new Error('Для работы Tabs, нужен контейнер');
  return context;
};
export var TabsContextProvider = function TabsContextProvider(_ref) {
  var children = _ref.children,
    isFirst = _ref.isFirst,
    mode = _ref.mode,
    value = _ref.value,
    onChange = _ref.onChange,
    type = _ref.type;
  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: useMemo(function () {
      return {
        type: type,
        isFirst: isFirst,
        mode: mode,
        value: value,
        onChange: onChange
      };
    }, [type, isFirst, mode, value, onChange])
  }, children);
};